const TRAVEL_FEES_TYPES = {
  transportFee: 'transportFee',
  travelTimeFee: 'travelTimeFee',
  costOfStayFee: 'costOfStayFee',
  generalTravelFee: 'generalTravelFee'
};

export default TRAVEL_FEES_TYPES;
